import React, { useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { EAuthData } from '../Provider/EAuthProvider';
import { employer_nav } from './Navs';
import { useAppType } from '../../provider/AppTypeProvider';

const EmployerRoutes = () => {
    const { user } = EAuthData();
    const { switchAppType } = useAppType();

    // Set app type to employer when this component loads
    useEffect(() => {
        switchAppType('employer');
    }, [switchAppType]);

    useEffect(() => {
        console.log('👤 EmployerRoutes - User state:', {
            exists: !!user,
            isAuthenticated: user?.isAuthenticated,
            userType: user?.userType,
            isActive: user?.isActive,
            verificationStatus: user?.verificationStatus
        });
    }, [user]);

    // Helper function to check if employer should have access to private routes
    const canAccessPrivateRoutes = () => {
        return user && user.isAuthenticated && user.isActive === true;
    };

    return (
        <Routes>
            {employer_nav.map((r, i) => {
                // Convert full paths to relative paths (remove /employer prefix)
                const relativePath = r.path.startsWith('/employer') 
                    ? r.path.replace('/employer', '') || '/'
                    : r.path;

                if (r.isPrivate) {
                    if (r.subMenu) {
                        // Handle subMenu routes
                        return r.subMenu.map((sub_r, sub_i) => {
                            const subRelativePath = sub_r.path.startsWith('/employer')
                                ? sub_r.path.replace('/employer', '') || '/'
                                : sub_r.path;
                            
                            return (
                                <Route 
                                    key={`sub-${sub_i}`} 
                                    path={subRelativePath} 
                                    element={canAccessPrivateRoutes() ? sub_r.element : <Navigate to="/employer/application-submitted" replace />} 
                                />
                            );
                        });
                    }
                    return (
                        <Route
                            key={i}
                            path={relativePath}
                            element={canAccessPrivateRoutes() ? r.element : <Navigate to="/employer/application-submitted" replace />}
                        />
                    );
                } else {
                    return (
                        <Route
                            key={i}
                            path={relativePath}
                            element={r.element}
                        />
                    );
                }
            })}
        </Routes>
    );
};

export default EmployerRoutes;